const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '0px',
  threshold: 0.05,
};

function pushSectionViewToGTM(sectionId) {
    window?.GTMtracker.pushEvent({
      event: 'gtm_section_view',
      data: {
        section_name: sectionId,
      },
      action: 'section_view',
    });
}

function initializeObserver() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        pushSectionViewToGTM(entry.target.id);
      }
    });
  }, OBSERVER_OPTIONS);


  return observer;
}


function addSectionViewTracking(sectionIds = []) {
  const observer = initializeObserver();
  sectionIds.forEach((sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      observer.observe(sectionElement);
    }
  });
}

export default {
  initialize: addSectionViewTracking,
};
